import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import moment from 'moment-timezone'
import {
    HOURLY_INVOICE_PARTY_SELECTION,
    partyNameLoopUp,
} from 'components/ui/utils/constant'
import { timezones } from 'components/template/Account/components/MediationTime'
dayjs.extend(timezone)
dayjs.extend(utc)

const momentTimezone = require('moment-timezone')

function isSameOrBeforeForDayjs(date1, date2, unit = 'day') {
    return date1.isSame(date2, unit) || date1.isBefore(date2, unit)
}

export function convertToArrayForCaseBullets(
    obj,
    isOdrMediator,
    mediatorSettings = {}
) {
    // return Object.keys(obj)
    //     .map((key) => {
    //         if (isOdrMediator && key === 'briefStatus')
    //             return null // Skip "Brief" if isOdrMediator is true
    //         else if (!isOdrMediator && key === 'keyDocumentStatus') return null // Skip "keyDocumentStatus" if isOdrMediator is false
    //         return {
    //             key:
    //                 key === 'paymentStatus'
    //                     ? 'Payment'
    //                     : key === 'briefStatus'
    //                     ? mediatorSettings?.brief_text
    //                         ? mediatorSettings?.brief_text
    //                         : 'Brief'
    //                     : key === 'onboardingStatus'
    //                     ? 'Onboarding'
    //                     : key === 'keyDocumentStatus'
    //                     ? 'Key Documents'
    //                     : null,
    //             color: obj[key]?.color,
    //             status: obj[key]?.status,
    //         }
    //     })
    //     .filter(Boolean) // Removes null values

    return Object.keys(obj)
        .filter((key) => {
            if (isOdrMediator && key === 'briefStatus') return false
            if (!isOdrMediator && key === 'keyDocumentStatus') return false
            return true
        })
        .map((key) => {
            const labels = {
                paymentStatus: 'Payment',
                briefStatus: mediatorSettings?.brief_text || 'Brief',
                onboardingStatus: 'Onboarding',
                keyDocumentStatus: 'Key Documents',
            }

            return {
                key: labels[key] || null,
                color: obj[key]?.color,
                status: obj[key]?.status,
            }
        })
        .filter((item) => item.key)
}

export const getNameProfile = (
    first,
    last,
    background = null,
    textColor = null
) => {
    if (!first || !last) return ''
    let url = `https://ui-avatars.com/api/?name=${first}+${last}&background=${background ? background : 'random'
        }`
    if (textColor) {
        url = `${url}&color=${textColor}`
    }
    return url
}

export const generateStatusData = (status, dueInDays) => {
    switch (status) {
        case 'green':
            return { status: 'Completed', color: 'green' }
        case 'yellow':
            return {
                status:
                    dueInDays === 0
                        ? `Due Today`
                        : `Due in ${dueInDays} ${dueInDays === 1 ? 'day' : 'days'
                        }`,
                color: 'yellow',
            }
        case 'red':
            return {
                status:
                    dueInDays === 0
                        ? // ? `1 day overdue`
                        `Due Today`
                        : `${dueInDays} ${dueInDays === 1 ? 'day' : 'days'
                        } overdue`,
                color: 'red',
            }
        case 'grey':
            return {
                status: dueInDays,
                color: 'grey',
            }
        default:
            return { status: 'Unknown', color: 'gray' }
    }
}

export function convertToTimezone(date, timezone = 'US/Pacific') {
    return momentTimezone(date).tz(timezone)
    // .format("YYYY-MM-DD HH:mm:ss");
}

export function convertCentsToDollars(cents = 0) {
    return (cents / 100).toFixed(2)
}

export function convertDollarToCents(dollars = 0) {
    return dollars * 100
}

export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return ''

    const cleaned = ('' + phoneNumber).replace(/\D/g, '')

    if (cleaned.length === 11 && cleaned[0] === '1') {
        const match = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            return `1 (${match[1]}) ${match[2]}-${match[3]}`
        }
    } else if (cleaned.length === 10) {
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`
        }
    }

    return phoneNumber
}

export const determineStatusWithDescription = ({
    bookingDate,
    mediationDate,
    isPaymentDone,
    isBriefSubmitted,
    isOnboardingComplete,
    mediatorData,
    onboardingCompletionDate = null,
    isKeyDocSubmitted,
    isDepZeroCase = false,
    isGscCase = false,
    hourlyPayment = [],
    isConsole = false,
    caseSettingSnapShot = null,
}) => {
    // console.log('caseSettingSnapShot', { caseSettingSnapShot })
    const hasCustomReminderForThisCase =
        caseSettingSnapShot?.reminder_schedules &&
        Object.keys(caseSettingSnapShot?.reminder_schedules).length > 0
    const customReminderForThisCase = caseSettingSnapShot?.reminder_schedules

    // console.log('hasCustomReminderForThisCase, customReminderForThisCase', {
    //     hasCustomReminderForThisCase,
    //     customReminderForThisCase,
    // })

    const firstReminderOfPaymentByMediatorSetting = hasCustomReminderForThisCase
        ? customReminderForThisCase?.payment?.['reminder_1_days'] || 0
        : mediatorData?.reminderDays?.payment_reminder_days

    const firstReminderOfBriefMediatorSetting = hasCustomReminderForThisCase
        ? customReminderForThisCase?.brief?.['reminder_1_days'] || 0
        : mediatorData?.reminderDays?.brief_reminder_days
    // const todayDayjs = dayjs('2025-09-14')
    //     .tz(timezone)
    //     .startOf('day')

    const todayDayjs = dayjs().tz(mediatorData?.timezone).startOf('day')

    const bookingDateWithTz = dayjs.utc(bookingDate).tz(mediatorData?.timezone)
    const mediationDataStartOf = dayjs.utc(mediationDate).startOf('day')

    const daysToMed = Math.ceil(
        mediationDataStartOf.diff(bookingDateWithTz, 'day', true)
    )

    const xDaysAfterOnboardingCompletionDate =
        onboardingCompletionDate !== null
            ? dayjs
                .utc(onboardingCompletionDate)
                .tz(mediatorData?.timezone)
                .add(firstReminderOfPaymentByMediatorSetting, 'day')
                .startOf('day')
            : null

    const xDaysBeforeBriefMediationDate = mediationDataStartOf.subtract(
        firstReminderOfBriefMediatorSetting,
        'day'
    )

    let paymentStatus, briefStatus, onboardingStatus, keyDocumentStatus

    if (isPaymentDone) {
        paymentStatus = generateStatusData('green')
    } else {
        if (isGscCase === true || isDepZeroCase === true) {
            if (hourlyPayment?.length <= 0) {
                paymentStatus = generateStatusData('grey', 'No Invoice sent')
            } else {
                const firstPending = hourlyPayment.find(
                    (invoice) => invoice.status === 'pending'
                )

                const dueDate = dayjs(firstPending?.due_date)
                    .clone()
                    .startOf('day')

                const isDueDateAfterToday = dueDate.isAfter(todayDayjs)
                const isDueDateBeforeToday = dueDate.isBefore(todayDayjs)

                const daysDiffToday = Math.ceil(
                    dueDate.diff(todayDayjs, 'days', true)
                )

                const invoiceCreatedDate = firstPending?.created_at
                    ? dayjs
                        .utc(firstPending?.created_at)
                        .tz(mediatorData?.timezone)
                        .startOf('day')
                    : null

                const daysDiffOnCreatedInvoice = invoiceCreatedDate
                    ? Math.ceil(todayDayjs.diff(dueDate, 'days', true))
                    : Math.ceil(
                        todayDayjs.diff(invoiceCreatedDate, 'days', true)
                    )

                if (isDueDateAfterToday) {
                    paymentStatus = generateStatusData('yellow', daysDiffToday)
                } else if (isDueDateBeforeToday) {
                    paymentStatus = generateStatusData(
                        daysDiffOnCreatedInvoice === 0 ? 'yellow' : 'red',
                        daysDiffOnCreatedInvoice
                    )
                } else {
                    paymentStatus = generateStatusData('yellow', 0)
                }
            }
        } else {
            if (onboardingCompletionDate === null || !isOnboardingComplete) {
                paymentStatus = generateStatusData(
                    'grey',
                    isDepZeroCase ? 'No Invoice sent' : 'Onboarding Pending'
                )
            } else {
                const dueDate = xDaysAfterOnboardingCompletionDate
                    .clone()
                    .startOf('day')

                const isDueDateAfterToday = dueDate.isAfter(todayDayjs)
                const isDueDateBeforeToday = dueDate.isBefore(todayDayjs)

                const isDueDateBeforeMediation =
                    dueDate.isBefore(mediationDataStartOf)
                const isDueDateAfterMediation =
                    dueDate.isAfter(mediationDataStartOf)

                const daysDiffToday = Math.ceil(
                    dueDate.diff(todayDayjs, 'days', true)
                )
                const onboardingDate = onboardingCompletionDate
                    ? dayjs
                        .utc(onboardingCompletionDate)
                        .tz(mediatorData?.timezone)
                        .startOf('day')
                    : null

                const daysDiffOnboarding =
                    isDueDateBeforeMediation && onboardingDate
                        ? Math.ceil(
                            todayDayjs.diff(
                                xDaysAfterOnboardingCompletionDate,
                                'days',
                                true
                            )
                        )
                        : Math.ceil(
                            todayDayjs.diff(onboardingDate, 'days', true)
                        )

                if (isDueDateAfterToday && isDueDateBeforeMediation) {
                    paymentStatus = generateStatusData('yellow', daysDiffToday)
                } else if (isDueDateBeforeToday || isDueDateAfterMediation) {
                    paymentStatus = generateStatusData(
                        daysDiffOnboarding === 0 ? 'yellow' : 'red',
                        daysDiffOnboarding
                    )
                } else {
                    paymentStatus = generateStatusData('yellow', 0)
                }
            }
        }
    }

    if (isBriefSubmitted) {
        briefStatus = generateStatusData('green')
    } else {
        const isLessOrSameSevenOrxDaysBeforeBooking =
            daysToMed <= 7 ||
            xDaysBeforeBriefMediationDate
                .clone()
                .startOf('day')
                .isBefore(bookingDateWithTz)

        const dueDate = isLessOrSameSevenOrxDaysBeforeBooking
            ? bookingDateWithTz.clone().startOf('day')
            : xDaysBeforeBriefMediationDate.clone().startOf('day')

        const isDueDateAfterBooking = dueDate.isAfter(bookingDateWithTz, 'day')
        // const isDueDateSameBooking = dueDate.isSame(bookingDateWithTz, 'day')

        const isDueDateAfterToday = dueDate.isAfter(todayDayjs)
        // const isDueDateBeforeToday = dueDate.isBefore(todayDayjs, 'day')

        // console.log('--------------')
        // console.log(
        //     'isLessOrSameSevenOrxDaysBeforeBooking',
        //     isLessOrSameSevenOrxDaysBeforeBooking
        // )
        // console.log('isDueDateBeforeToday', isDueDateBeforeToday)
        // console.log('isDueDateSameBooking', isDueDateSameBooking)
        // console.log('isDueDateAfterToday', isDueDateAfterToday)
        // todayDayjs.isSame(bookingDateWithTz, 'day')
        // todayDayjs.isSame(bookingDateWithTz, 'day')
        // console.log(
        //     `  isLessOrSameSevenOrxDaysBeforeBooking &&
        //     todayDayjs.isSame(bookingDateWithTz, 'day')`,
        //     isLessOrSameSevenOrxDaysBeforeBooking &&
        //         todayDayjs.isSame(bookingDateWithTz, 'day')
        // )

        // console.log(
        //     `isDueDateAfterToday &&
        //     isLessOrSameSevenOrxDaysBeforeBooking`,
        //     isDueDateAfterToday && isLessOrSameSevenOrxDaysBeforeBooking
        // )

        // console.log(
        //     `isDueDateAfterBooking && isDueDateAfterToday`,
        //     isDueDateAfterBooking && isDueDateAfterToday
        // )
        // console.log('--------------')

        if (
            isLessOrSameSevenOrxDaysBeforeBooking &&
            todayDayjs.isSame(bookingDateWithTz, 'day')
        ) {
            briefStatus = generateStatusData('yellow', 0)
        } else if (
            isDueDateAfterToday &&
            isLessOrSameSevenOrxDaysBeforeBooking
        ) {
            briefStatus = generateStatusData(
                'yellow',
                todayDayjs.diff(bookingDateWithTz, 'day')
            )
        } else if (isDueDateAfterBooking && isDueDateAfterToday) {
            briefStatus = generateStatusData(
                'yellow',
                Math.ceil(
                    xDaysBeforeBriefMediationDate.diff(todayDayjs, 'day', true)
                )
            )
        } else {
            // console.log(
            //     '-----------------------',
            //     'isOnboardingComplete',
            //     isOnboardingComplete,
            //     'isLessOrSameSevenOrxDaysBeforeBooking',
            //     isLessOrSameSevenOrxDaysBeforeBooking,
            //     'bookingDateWithTz',
            //     bookingDateWithTz.format(),
            //     'todayDayjs',
            //     todayDayjs.format()
            // )
            const daysDiff = Math.ceil(
                todayDayjs.diff(
                    isLessOrSameSevenOrxDaysBeforeBooking
                        ? bookingDateWithTz
                        : xDaysBeforeBriefMediationDate,
                    'day',
                    true
                )
            )
            // console.log('daysDiff', daysDiff)
            // console.log('----------------')
            briefStatus = generateStatusData(
                daysDiff === 0 ? 'yellow' : 'red',
                daysDiff
            )
            // console.log('briefStatus', briefStatus)
        }
    }

    if (isKeyDocSubmitted) {
        keyDocumentStatus = generateStatusData('green')
    } else {
        const isLessOrSameSevenOrxDaysBeforeBooking =
            daysToMed <= 7 ||
            xDaysBeforeBriefMediationDate
                .clone()
                .startOf('day')
                .isBefore(bookingDateWithTz)

        const dueDate = isLessOrSameSevenOrxDaysBeforeBooking
            ? bookingDateWithTz.clone().startOf('day')
            : xDaysBeforeBriefMediationDate.clone().startOf('day')

        const isDueDateAfterBooking = dueDate.isAfter(bookingDateWithTz, 'day')
        // const isDueDateSameBooking = dueDate.isSame(bookingDateWithTz, 'day')

        const isDueDateAfterToday = dueDate.isAfter(todayDayjs)
        // const isDueDateBeforeToday = dueDate.isBefore(todayDayjs, 'day')

        // console.log('--------------')
        // console.log(
        //     'isLessOrSameSevenOrxDaysBeforeBooking',
        //     isLessOrSameSevenOrxDaysBeforeBooking
        // )
        // console.log('isDueDateBeforeToday', isDueDateBeforeToday)
        // console.log('isDueDateSameBooking', isDueDateSameBooking)
        // console.log('isDueDateAfterToday', isDueDateAfterToday)
        // todayDayjs.isSame(bookingDateWithTz, 'day')
        // todayDayjs.isSame(bookingDateWithTz, 'day')
        // console.log(
        //     `  isLessOrSameSevenOrxDaysBeforeBooking &&
        //     todayDayjs.isSame(bookingDateWithTz, 'day')`,
        //     isLessOrSameSevenOrxDaysBeforeBooking &&
        //         todayDayjs.isSame(bookingDateWithTz, 'day')
        // )

        // console.log(
        //     `isDueDateAfterToday &&
        //     isLessOrSameSevenOrxDaysBeforeBooking`,
        //     isDueDateAfterToday && isLessOrSameSevenOrxDaysBeforeBooking
        // )

        // console.log(
        //     `isDueDateAfterBooking && isDueDateAfterToday`,
        //     isDueDateAfterBooking && isDueDateAfterToday
        // )
        // console.log('--------------')

        if (
            isLessOrSameSevenOrxDaysBeforeBooking &&
            todayDayjs.isSame(bookingDateWithTz, 'day')
        ) {
            keyDocumentStatus = generateStatusData('yellow', 0)
        } else if (
            isDueDateAfterToday &&
            isLessOrSameSevenOrxDaysBeforeBooking
        ) {
            keyDocumentStatus = generateStatusData(
                'yellow',
                todayDayjs.diff(bookingDateWithTz, 'day')
            )
        } else if (isDueDateAfterBooking && isDueDateAfterToday) {
            keyDocumentStatus = generateStatusData(
                'yellow',
                Math.ceil(
                    xDaysBeforeBriefMediationDate.diff(todayDayjs, 'day', true)
                )
            )
        } else {
            const daysDiff = Math.ceil(
                todayDayjs.diff(
                    isLessOrSameSevenOrxDaysBeforeBooking
                        ? bookingDateWithTz
                        : xDaysBeforeBriefMediationDate,
                    'day',
                    true
                )
            )
            keyDocumentStatus = generateStatusData(
                daysDiff === 0 ? 'yellow' : 'red',
                daysDiff
            )
        }
    }

    if (isOnboardingComplete) {
        onboardingStatus = generateStatusData('green')
    } else {
        const fiveDaysAfterBooking = bookingDateWithTz
            .clone()
            .add(daysToMed > 7 ? 5 : 0, 'day')

        if (isSameOrBeforeForDayjs(todayDayjs, fiveDaysAfterBooking)) {
            onboardingStatus = generateStatusData(
                'yellow',
                daysToMed > 7
                    ? Math.ceil(
                        fiveDaysAfterBooking.diff(todayDayjs, 'day', true)
                    )
                    : 0
            )
        } else {
            onboardingStatus = generateStatusData(
                'red',
                Math.ceil(
                    todayDayjs.diff(
                        daysToMed > 7
                            ? fiveDaysAfterBooking
                            : bookingDateWithTz,
                        'day',
                        true
                    )
                )
            )
        }
    }

    return { onboardingStatus, paymentStatus, briefStatus, keyDocumentStatus }
}

export const dynamicHeight = (itemLength) => {
    if (itemLength === 1 || itemLength === 0) {
        return `h-24`
    } else if (itemLength === 2) {
        return `h-32`
    } else if (itemLength === 3) {
        return `h-40`
    } else if (itemLength === 4) {
        return `h-48`
    } else {
        return 'h-52 overflow-y-auto'
    }
}

export const extractFileName = (url) => {
    if (!url) return 'Unknown File'
    return url.split('/').pop()
}

export const calculateStripeProcessingFee = (
    amount = 0,
    convertInCent = true,
    notAdd30Cent = false
) => {
    let fee = notAdd30Cent ? amount * 0.029 : amount * 0.029 + 0.3
    fee = Math.floor(fee * 100) / 100
    if (convertInCent) {
        return Math.floor(fee * 100)
    }
    return fee
}

export const handleDownloadFile = async (url) => {
    try {
        const response = await fetch(url, { mode: 'cors' })
        const blob = await response.blob()
        const fileName = extractFileName(url)
        const blobUrl = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
        console.error('Download failed:', error)
    }
}

export const getDaysFromDate = (dateString) => {
    const dueDate = new Date(dateString)
    const currentDate = new Date()

    dueDate.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0)

    const timeDiff = dueDate - currentDate
    const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))

    return dayDiff
}

export const formatDate = (dateString) => {
    const date = new Date(dateString)
    const options = { year: 'numeric', month: 'short', day: 'numeric' }
    return date.toLocaleDateString('en-US', options)
}

export const decimalToTime = (decimal) => {
    const hours = Math.floor(decimal)
    const minutes = Math.round((decimal - hours) * 60)
    return `${hours}:${minutes.toString().padStart(2, '0')}`
}

const getNextWorkingDay = (date, interval = 3, isSkipInterval = false) => {
    if (!date) return null

    let nextDate = date.clone()
    if (!isSkipInterval) {
        nextDate.add(interval, 'days')
    }

    const day = nextDate.isoWeekday()
    if (day === 6) {
        nextDate.add(2, 'days')
    } else if (day === 7) {
        nextDate.add(1, 'days')
    }

    return nextDate
}

export const calculateDueDateFromDays = (days) => {
    if (!days) return null

    const today = moment().startOf('day')
    const dueDate = today.clone().add(days, 'days')

    // Check if the due date falls on a weekend and move to Monday
    const day = dueDate.isoWeekday()
    if (day === 6) {
        dueDate.add(2, 'days')
    } else if (day === 7) {
        dueDate.add(1, 'days')
    }

    return dueDate.format('YYYY-MM-DD')
}

export const reminderList = (dueDate, reminderSettings = null) => {
    const invoiceDueDate = moment(dueDate)
    const todayDate = moment()

    // Use custom reminder settings if provided, otherwise use default 3 days
    const reminder1Days = reminderSettings?.reminder_1_days ?? 3
    const reminder2Days = reminderSettings?.reminder_2_days ?? 3
    const reminder3Days = reminderSettings?.reminder_3_days ?? 3

    let firstReminder = getNextWorkingDay(moment(invoiceDueDate), null, true)

    if (firstReminder.isBefore(todayDate, 'day')) {
        return {
            firstReminder: null,
            secondReminder: null,
            thirdReminder: null,
            fourthReminder: null,
        }
    }

    let secondReminder = firstReminder
        ? getNextWorkingDay(
            moment(firstReminder).add(reminder1Days, 'days'),
            null,
            true
        )
        : null

    let thirdReminder = secondReminder
        ? getNextWorkingDay(
            moment(secondReminder).add(reminder2Days, 'days'),
            null,
            true
        )
        : null

    let fourthReminder = thirdReminder
        ? getNextWorkingDay(
            moment(thirdReminder).add(reminder3Days, 'days'),
            null,
            true
        )
        : null

    return {
        firstReminder: firstReminder.format('YYYY-MM-DD'),
        secondReminder: secondReminder?.format('YYYY-MM-DD') || null,
        thirdReminder: thirdReminder?.format('YYYY-MM-DD') || null,
        fourthReminder: fourthReminder?.format('YYYY-MM-DD') || null,
    }
}

export const transformReminders = (originalReminders) => {
    const reminderKeys = ['first', 'second', 'third', 'fourth']
    const transformedReminders = {}

    reminderKeys.forEach((key) => {
        const reminderKey = `${key}Reminder`
        transformedReminders[key] = originalReminders[reminderKey]
            ? {
                date: originalReminders[reminderKey],
                is_sent: false,
            }
            : null
    })

    return transformedReminders
}

export const getSelectedClients = (values, selectedPartyData) => {
    const {
        client1Data,
        client2Data,
        selectedOption,
        clients,
        additionalDefendantParties,
        additionalPlaintiffParties,
    } = values

    // Check if this is a GSC case (no client2Data)
    const isGscCase = !client2Data

    if (
        selectedOption === HOURLY_INVOICE_PARTY_SELECTION.BOTH ||
        selectedOption === HOURLY_INVOICE_PARTY_SELECTION.ALL
    ) {
        // Build client_information object
        const clientInfo = {}

        // Only add client1Data if client_id exists
        if (client1Data?.client_information?.client_id) {
            clientInfo[client1Data.client_information.client_id] = {
                name: client1Data.client_information.name,
                phone: client1Data.client_information.phone_number,
                email: client1Data.client_information.email,
                address: client1Data.client_information.address,
                invoice_emails: client1Data.invoice_emails,
                role: client1Data.client_information.role,
                position: 0,
            }
        }

        // Only add client2Data if it exists (not GSC case)
        if (client2Data) {
            clientInfo[client2Data.client_information.client_id] = {
                name: client2Data.client_information.name,
                phone: client2Data.client_information.phone_number,
                email: client2Data.client_information.email,
                address: client2Data.client_information.address,
                invoice_emails: client2Data.invoice_emails,
                role: client2Data.client_information.role,
                position: 0,
            }
        }

        // Add additional parties only if they exist
        if (
            client1Data?.client_information?.client_id &&
            additionalPlaintiffParties &&
            additionalPlaintiffParties.length > 0
        ) {
            Object.assign(
                clientInfo,
                Object.fromEntries(
                    additionalPlaintiffParties.map((item) => [
                        item.client_information.client_id,
                        {
                            name: item.client_information.name,
                            phone: item.client_information.phone_number,
                            email: item.client_information.email,
                            address: item.client_information.address,
                            invoice_emails: item.invoice_emails,
                            role: item.client_information.role,
                            position: item.client_information.position,
                        },
                    ])
                )
            )
        }

        if (
            additionalDefendantParties &&
            additionalDefendantParties.length > 0
        ) {
            Object.assign(
                clientInfo,
                Object.fromEntries(
                    additionalDefendantParties.map((item) => [
                        item.client_information.client_id,
                        {
                            name: item.client_information.name,
                            phone: item.client_information.phone_number,
                            email: item.client_information.email,
                            address: item.client_information.address,
                            invoice_emails: item.invoice_emails,
                            role: item.client_information.role,
                            position: item.client_information.position,
                        },
                    ])
                )
            )
        }

        // Build clients array from updated client data (client1Data, client2Data, additional parties)
        // while preserving calculated financial values (amount, processing_fee, percentage) from values.clients
        const financialDataMap = new Map(
            clients.map((party) => [
                party.value,
                {
                    amount: party.amount,
                    processing_fee: party.processing_fee,
                    percentage: party.percentage,
                },
            ])
        )

        const updatedClientsArray = []

        // Add client1Data
        if (client1Data) {
            const financialData =
                financialDataMap.get(
                    client1Data.client_information.client_id
                ) || {}
            updatedClientsArray.push({
                name: client1Data.client_information.name,
                email: client1Data.client_information.email,
                address: client1Data.client_information.address,
                client_id: client1Data.client_information.client_id,
                role: client1Data.client_information.role,
                primary_party_id:
                    client1Data.client_information.primary_party_id || null,
                invoice_emails: client1Data.invoice_emails || '',
                amount: financialData.amount || 0,
                processing_fee: financialData.processing_fee || 0,
                percentage: financialData.percentage || 0,
            })
        }

        // Add client2Data if it exists (not GSC case)
        if (client2Data) {
            const financialData =
                financialDataMap.get(
                    client2Data.client_information.client_id
                ) || {}
            updatedClientsArray.push({
                name: client2Data.client_information.name,
                email: client2Data.client_information.email,
                address: client2Data.client_information.address,
                client_id: client2Data.client_information.client_id,
                role: client2Data.client_information.role,
                primary_party_id:
                    client2Data.client_information.primary_party_id || null,
                invoice_emails: client2Data.invoice_emails || '',
                amount: financialData.amount || 0,
                processing_fee: financialData.processing_fee || 0,
                percentage: financialData.percentage || 0,
            })
        }

        // Add additional plaintiff parties
        if (
            additionalPlaintiffParties &&
            additionalPlaintiffParties.length > 0
        ) {
            additionalPlaintiffParties.forEach((party) => {
                const financialData =
                    financialDataMap.get(party.client_information.client_id) ||
                    {}
                updatedClientsArray.push({
                    name: party.client_information.name,
                    email: party.client_information.email,
                    address: party.client_information.address,
                    client_id: party.client_information.client_id,
                    role: party.client_information.role,
                    primary_party_id:
                        party.client_information.primary_party_id || null,
                    invoice_emails: party.invoice_emails || '',
                    amount: financialData.amount || 0,
                    processing_fee: financialData.processing_fee || 0,
                    percentage: financialData.percentage || 0,
                })
            })
        }

        // Add additional defendant parties
        if (
            additionalDefendantParties &&
            additionalDefendantParties.length > 0
        ) {
            additionalDefendantParties.forEach((party) => {
                const financialData =
                    financialDataMap.get(party.client_information.client_id) ||
                    {}
                updatedClientsArray.push({
                    name: party.client_information.name,
                    email: party.client_information.email,
                    address: party.client_information.address,
                    client_id: party.client_information.client_id,
                    role: party.client_information.role,
                    primary_party_id:
                        party.client_information.primary_party_id || null,
                    invoice_emails: party.invoice_emails || '',
                    amount: financialData.amount || 0,
                    processing_fee: financialData.processing_fee || 0,
                    percentage: financialData.percentage || 0,
                })
            })
        }

        return {
            clientIds: updatedClientsArray.map((c) => c.client_id),
            client_information: clientInfo,
            clients: updatedClientsArray,
        }
    }

    // console.log('getSelectedClients - selectedPartyData:', selectedPartyData)

    // Handle case where selectedPartyData might be null (shouldn't happen but safety check)
    if (!selectedPartyData) {
        console.error('selectedPartyData is null or undefined')
        return {
            clientIds: [],
            client_information: {},
            clients: [],
        }
    }

    return {
        clientIds: [selectedPartyData.client_information.client_id],
        client_information: {
            [selectedPartyData.client_information.client_id]: {
                name: selectedPartyData.client_information.name,
                email: selectedPartyData.client_information.email,
                address: selectedPartyData.client_information.address,
                phone: selectedPartyData.client_information.phone_number,
                invoice_emails: selectedPartyData.invoice_emails,
                role: selectedPartyData.client_information.role,
                position: selectedPartyData.client_information.position || 0,
            },
        },
        clients: [
            {
                name: selectedPartyData.client_information.name,
                email: selectedPartyData.client_information.email,
                address: selectedPartyData.client_information.address,
                client_id: selectedPartyData.client_information.client_id,
                role: selectedPartyData.client_information.role,
                primary_party_id:
                    selectedPartyData.client_information.primary_party_id ||
                    null,
                invoice_emails: selectedPartyData.invoice_emails || '',
                amount: values.subtotal,
                processing_fee: values.processing_fee,
                percentage: 100,
            },
        ],
    }
}

export const getImageNameFromUrl = (urlOrArray) => {
    if (Array.isArray(urlOrArray)) {
        return urlOrArray.map((url) => {
            const parts = url?.split('/')
            return parts?.[parts.length - 1]
        })
    } else if (typeof urlOrArray === 'string') {
        const parts = urlOrArray?.split('/')
        return parts?.[parts.length - 1]
    }
    return ''
}

export const getFileExtension = (fileNames) => {
    if (Array.isArray(fileNames)) {
        return fileNames.map((fileName) => {
            return fileName.split('.').pop().toLowerCase()
        })
    } else if (typeof fileNames === 'string') {
        return fileNames.split('.').pop().toLowerCase()
    }
    return []
}

export function safeParseArray(value) {
    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value)
            return Array.isArray(parsed) ? parsed : []
        } catch (e) {
            const isCheckSingleFile = value?.includes('https://')
            return isCheckSingleFile ? [value] : []
        }
    }
    return Array.isArray(value) ? value : []
}

export const isUUID = (str) => {
    const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    return uuidRegex.test(str)
}

export const parseBooleanVal = (val) => {
    if (val === true || val === 'true' || val === 1) return true
    return false
}

export const getPartyTypeByRole = (
    role,
    position = null,
    is_odr_mediator = false,
    isSystemCoupon = false,
    is_car_case_not_scheduled = false
) => {
    if (role === 'plaintiff' || role === 'primary_plaintiff') {
        return is_car_case_not_scheduled
            ? 'Initiating Party'
            : isSystemCoupon
            ? 'Initiating Party'
            : is_odr_mediator
                ? (position && position > 1 ? `Party ${position + 1}` : 'Party 1')
                : `Plaintiff${position ? ` ${position}` : ''}`
    } else if (role === 'defendant' || role === 'primary_defendant') {
        return is_car_case_not_scheduled
            ? 'Responding Party'
            : isSystemCoupon
            ? 'Responding Party'
            : is_odr_mediator
                ? (position && position > 1 ? `Party ${position + 1}` : 'Party 2')
                : `Defendant${position ? ` ${position}` : ''}`
    }
    return ''
}

export const getPrimaryAccessorByRole = (role) => {
    if (role === 'plaintiff' || role === 'primary_plaintiff') {
        return 'plaintiff_id'
    }
    if (role === 'defendant' || role === 'primary_defendant') {
        return 'defender_id'
    }
    return ''
}

export function getFullCaseName(caseName = '', additionalCaseNames = []) {
    if (additionalCaseNames?.length <= 0) {
        return caseName
    }

    return `${caseName}${additionalCaseNames?.length > 0
        ? `, ${additionalCaseNames?.join(', ')}`
        : ' '
        }`
}

export function expandAlternateParticipants(participants = []) {
    if (!Array.isArray(participants)) return []

    // After the participants-rows refactor, each alt email is its own
    // real `participants` row with its own name. The legacy
    // `alternate_emails` jsonb on the primary row is a dormant fallback
    // — NOT a source of additional display rows. Iterate participants
    // rows only. Drop the alternate_emails field from each row so any
    // downstream code that tried to expand it again gets an empty list.
    return participants.map(({ alternate_emails: _omit, ...rest }) => rest)
}

export const convertToAMPM = (timeString) => {
    const dateTimeString = dayjs().format('YYYY-MM-DD') + ' ' + timeString
    const utcTime = dayjs.utc(dateTimeString, 'YYYY-MM-DD HH:mm:ss')
    return utcTime.format('h:mm A')
}

export const getTime = (time) => {
    if (!time) return 'Invalid Time'

    // If time is a Date object, extract HH:mm from it
    if (time instanceof Date) {
        return dayjs(time).format('h:mm A')
    }

    // If time is a string, handle both 'HH:mm' and 'HH:mm:ss' formats
    if (typeof time === 'string') {
        // Extract first 5 characters for 'HH:mm' format
        const timeStr = time.substring(0, 5)
        // Try parsing with HH:mm format
        const parsed = dayjs(timeStr, 'HH:mm', true)
        if (parsed.isValid()) {
            return parsed.format('h:mm A')
        }
        // If that fails, try parsing as full datetime string
        const parsedFull = dayjs(time)
        if (parsedFull.isValid()) {
            return parsedFull.format('h:mm A')
        }
    }

    return 'Invalid Time'
}

export const findTimezoneLabel = (timezoneValue) => {
    const tz = timezones.find((tz) => tz.value === timezoneValue)
    return tz ? tz.shortLabel : ''
}

export const getTimeWithTimeZoneLabel = (time, timezone) => {
    const timeString = getTime(time)
    const timezoneLabel = findTimezoneLabel(timezone)
    return `${timeString} (${timezoneLabel})`
}

export const capitalizeEachWord = (str = '') => {
    if (!str || typeof str !== 'string') return str
    return str
        .split(' ')
        .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ')
}

export const getPartyLabelByRole = ({
    is_car_case_not_scheduled,
    isSystemCoupon,
    is_odr_mediator,
    is_gsc_case,
    party_role = '',
}) => {
    if (!party_role) return ''

    const partyNames = partyNameLoopUp(party_role)

    return (
        (is_car_case_not_scheduled && partyNames.is_car_case_not_scheduled) ||
        (isSystemCoupon && partyNames.systemCoupon) ||
        (is_odr_mediator && partyNames.odrMediator) ||
        (is_gsc_case && partyNames.gscCase) ||
        (party_role === 'plaintiff' ? 'Plaintiff' : 'Defendant')
    )
}
/**
 * Utility function to extract citation from text
 * Extracts document type citations in parentheses format: "Text (Document type)"
 * @param {string} text - Text that may contain citation in parentheses
 * @returns {Object} - { mainText: string, citation: string | null }
 */
export const extractCitation = (text) => {
    if (!text || typeof text !== 'string') {
        return { mainText: text || '', citation: null };
    }

    // Match pattern: text ending with (Document type)
    // Handles cases like: "Position text (Brief Document)" or "Date (Operative Complaint Document)"
    const citationRegex = /^(.+?)\s*\(([^)]+)\)\s*$/;
    const match = text.match(citationRegex);

    if (match) {
        const mainText = match[1].trim();
        const citation = match[2].trim();
        return { mainText, citation };
    }

    // No citation found, return original text
    return { mainText: text.trim(), citation: null };
};

/**
 * Extract citation from date/period string
 * Handles formats like: "January 15th, 2025 (Brief Document)" or "Circa January 15th, 2025 (Plaintiff Brief)"
 * @param {string} dateOrPeriod - Date or period string that may contain citation
 * @returns {Object} - { dateOrPeriod: string, citation: string | null }
 */
export const extractCitationFromDate = (dateOrPeriod) => {
    if (!dateOrPeriod || typeof dateOrPeriod !== 'string') {
        return { dateOrPeriod: dateOrPeriod || '', citation: null };
    }

    // Match pattern: date/period ending with (Document type)
    const citationRegex = /^(.+?)\s*\(([^)]+)\)\s*$/;
    const match = dateOrPeriod.match(citationRegex);

    if (match) {
        const dateOrPeriodText = match[1].trim();
        const citation = match[2].trim();
        return { dateOrPeriod: dateOrPeriodText, citation };
    }

    // No citation found, return original
    return { dateOrPeriod: dateOrPeriod.trim(), citation: null };
};
